import { useToast } from '@/hooks/use-toast';
import { Copy } from 'lucide-react';
import type { Asset } from '@/types/asset';

interface AssetDetailHeaderProps {
  readonly asset: Asset;
  readonly onAssetUpdate: (asset: Asset) => void;
  readonly isEditMode?: boolean;
  readonly isCreateMode?: boolean;
}

export function AssetDetailHeader({ asset, isCreateMode = false }: Readonly<AssetDetailHeaderProps>) {
  const { toast } = useToast();

  const handleCopyAssetCode = () => {
    navigator.clipboard.writeText(asset.code);
    toast({
      title: '✓ Asset code copied',
      description: `${asset.code} copied to clipboard`,
    });
  };

  return (
    <div className="space-y-2">
      {/* Asset Code as subheading */}
      <div className="flex items-center gap-3 mb-0">
        <button
          onClick={handleCopyAssetCode}
          className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors group"
        >
          <span className="font-semibold">{asset.code || 'NEW'}</span>
          {!isCreateMode && (
            <Copy className="h-3 w-3 opacity-0 group-hover:opacity-100 transition-opacity" />
          )}
        </button>
      </div>

      {/* Description/Name as main heading */}
      <div className="text-2xl font-bold">
        {asset.name || 'Untitled Asset'}
      </div>
    </div>
  );
}
